"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpectrum = void 0;
const getActiveSpectrum_1 = require("./getActiveSpectrum");
function getSpectrum(state, value) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(state);
    if (value === undefined && activeSpectrum?.id) {
        const index = activeSpectrum.index;
        return state.data[index];
    }
    if (typeof value === 'number') {
        return state.data[value] || undefined;
    }
    if (typeof value === 'string') {
        return state.data.find((spectrum) => spectrum.id === value);
    }
}
exports.getSpectrum = getSpectrum;
